import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactMethods = () => {
  const [activeMethod, setActiveMethod] = useState('phone');

  const contactMethods = [
    {
      id: 'phone',
      title: 'Sofortberatung',
      subtitle: 'Direkter Anruf',
      icon: 'Phone',
      description: 'Sprechen Sie sofort mit einem Anwalt. Keine Wartezeit, direkte Verbindung zu unseren Experten.',
      features: [
        'Sofortige Verbindung',
        'Durchschnittlich 2 Min Wartezeit',
        '24/7 verfügbar',
        'Alle Rechtsgebiete'
      ],
      pricing: '2,99 EUR/Minute',
      action: 'Jetzt anrufen',
      phone: '0900 1000 312',
      contact: {
        phone: '09001000312',
        email: 'info@advocall.de',
        fax: '+49 69 348 740 919'
      },
      bgColor: 'bg-conversion-accent',
      textColor: 'text-white'
    },
    {
      id: 'schedule',
      title: 'Terminberatung',
      subtitle: 'Geplantes Gespräch',
      icon: 'Calendar',
      description: 'Vereinbaren Sie einen festen Termin für eine ausführliche Beratung zu Ihrem Rechtsfall.',
      features: [
        'Fester Terminslot',
        'Ausführliche Beratung',
        'Vorbereitung möglich',
        'Spezialisierte Anwälte'
      ],
      pricing: 'Ab 89,00 EUR/30 Min',
      action: 'Termin buchen',
      bgColor: 'bg-primary',
      textColor: 'text-white'
    },
    {
      id: 'message',
      title: 'Schriftliche Anfrage',
      subtitle: 'Erste Einschätzung',
      icon: 'MessageSquare',
      description: 'Schildern Sie Ihren Fall schriftlich und erhalten Sie eine erste rechtliche Einschätzung.',
      features: [
        'Schriftliche Antwort',
        'Binnen 24h Rückmeldung',
        'Unverbindlich',
        'Professionelle Beratung'
      ],
      pricing: 'Ab 49,00 EUR',
      action: 'Nachricht senden',
      bgColor: 'bg-trust-builder',
      textColor: 'text-white'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Wählen Sie Ihren bevorzugten Kontaktweg
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Ob sofortige Hilfe oder geplante Beratung - wir bieten verschiedene Wege, 
            um die beste rechtliche Unterstützung für Ihre Situation zu finden.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {contactMethods?.map((method) => (
            <div
              key={method?.id}
              className={`relative bg-white rounded-2xl shadow-elevated border border-slate-200 overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-2 ${
                activeMethod === method?.id ? 'ring-2 ring-primary' : ''
              }`}
              onMouseEnter={() => setActiveMethod(method?.id)}
            >
              <div className={`${method?.bgColor} ${method?.textColor} p-6`}>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                      <Icon name={method?.icon} size={24} color="white" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold">{method?.title}</h3>
                      <p className="text-sm opacity-90">{method?.subtitle}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-bold">{method?.pricing}</div>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <p className="text-text-secondary mb-6">{method?.description}</p>

                <ul className="space-y-3 mb-8">
                  {method?.features?.map((feature, index) => (
                    <li key={index} className="flex items-center space-x-3">
                      <Icon name="Check" size={16} color="var(--color-trust-builder)" />
                      <span className="text-sm text-text-secondary">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  variant="default"
                  fullWidth
                  iconName={method?.icon}
                  iconPosition="left"
                  className={`${method?.bgColor} hover:opacity-90 ${method?.textColor} cta-button`}
                  onClick={() => {
                    if (method?.id === 'phone') {
                      window.location.href = 'tel:09001000312';
                    }
                  }}
                >
                  {method?.action}
                </Button>

                {method?.phone && (
                  <div className="mt-4 p-3 bg-muted rounded-lg">
                    <div className="flex items-center justify-center space-x-2">
                      <Icon name="Phone" size={16} color="var(--color-primary)" />
                      <a 
                        href="tel:09001000312"
                        className="font-mono text-lg font-bold text-primary hover:text-primary/80 transition-colors"
                      >
                        {method?.phone}
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;